module.exports = __webpack_public_path__ + "img/n2.9191e4a2.png";